"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _LinkPreview = _interopRequireDefault(require("../links/LinkPreview"));

var i18nKey = function i18nKey(key) {
  return "RichTextLib.image." + key;
};

var EditImagePopoverPreview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditImagePopoverPreview, _Component);

  function EditImagePopoverPreview() {
    (0, _classCallCheck2.default)(this, EditImagePopoverPreview);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditImagePopoverPreview).apply(this, arguments));
  }

  (0, _createClass2.default)(EditImagePopoverPreview, [{
    key: "handleMouseDown",
    value: function handleMouseDown(evt) {
      // Prevent default to avoid blurring the editor
      // see https://git.hubteam.com/HubSpot/rich-text-lib/issues/344
      evt.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          href = _this$props.href,
          linkType = _this$props.linkType,
          linkDisplayName = _this$props.linkDisplayName,
          onSrcChange = _this$props.onSrcChange,
          onImageRemove = _this$props.onImageRemove;
      return _react.default.createElement("div", {
        className: "p-x-5 p-y-3",
        tabIndex: "-1"
      }, _react.default.createElement(_UIFlex.default, {
        align: "center",
        justify: "center"
      }, _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UILink.default, {
        onClick: this.props.onEdit,
        onMouseDown: this.handleMouseDown
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('edit')
      }))), _react.default.createElement(_UIBox.default, {
        className: "p-left-3 m-left-3 popover-preview__tail-node"
      }, _react.default.createElement(_UILink.default, {
        onClick: onSrcChange,
        onMouseDown: this.handleMouseDown
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('replace')
      }))), _react.default.createElement(_UIBox.default, {
        className: "p-left-3 m-left-3 popover-preview__tail-node"
      }, _react.default.createElement(_UILink.default, {
        onClick: onImageRemove,
        onMouseDown: this.handleMouseDown
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('remove')
      }))), href && _react.default.createElement(_LinkPreview.default, {
        className: "p-left-3 m-left-3 popover-preview__tail-node",
        href: href,
        linkType: linkType,
        linkDisplayName: linkDisplayName
      })));
    }
  }]);
  return EditImagePopoverPreview;
}(_react.Component);

exports.default = EditImagePopoverPreview;
EditImagePopoverPreview.propTypes = {
  href: _propTypes.default.string,
  linkDisplayName: _propTypes.default.string,
  linkType: _propTypes.default.string,
  onEdit: _propTypes.default.func.isRequired,
  onSrcChange: _propTypes.default.func.isRequired,
  onImageRemove: _propTypes.default.func.isRequired
};
module.exports = exports.default;